initMenuMobile('#btn-mobile', '#nav-header-bottom .menu-logo')

function initMenuMobile(btnOpenMobile, navSite) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);
    const events = ['click', 'touchstart'];

    const btn = select(btnOpenMobile);
    const menuLogo = select(navSite);
    const navBottom = select('#nav-header-bottom');
    const items = selectAll('#menu-site .menu-item-header');

    if (!btn || !menuLogo) return;

    /* o drawer fica colado ao fim do #nav-header-bottom (top:100% no CSS);
       aqui só medimos onde a barra termina p/ o drawer preencher o resto da tela */
    function syncDrawerOffset() {
        if (!navBottom) return;
        const bottom = Math.round(navBottom.getBoundingClientRect().bottom);
        menuLogo.style.setProperty('--header-h', bottom + 'px');
    }

    events.forEach(evt => btn.addEventListener(evt, toggleMenuMobile));

    function toggleMenuMobile(event) {
        if (event.type === 'touchstart') event.preventDefault();

        syncDrawerOffset();
        menuLogo.classList.toggle('active');

        const active = menuLogo.classList.contains('active');
        btn.setAttribute('aria-expanded', active);
        document.body.classList.toggle('menu-mobile-open', active);
        btn.setAttribute('aria-label', active ? 'Fechar Menu' : 'Abrir Menu');

        if (!active) closeAllSubmenus();
    }

    /* accordion dos submenus — só atua com o drawer mobile aberto */
    items.forEach(item => {
        const trigger = item.querySelector('.name-menu');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
            if (!menuLogo.classList.contains('active')) return; /* desktop segue no hover */
            const wasOpen = item.classList.contains('open');
            closeAllSubmenus();
            if (!wasOpen) item.classList.add('open');
        });
    });

    function closeAllSubmenus() {
        items.forEach(i => i.classList.remove('open'));
    }

    window.addEventListener('resize', () => {
        if (menuLogo.classList.contains('active')) syncDrawerOffset();
    });
}
